import React, { useState } from "react";
import { IFeedbackQuestion } from "../feedback.type";
import { Typography } from "@material-ui/core";
import { feedbackStyle } from "../style";

export const ScaleFeedbackQuestion: React.FC<IFeedbackQuestion> = (props) => {
	const [rating, setRating] = useState(0);
	const [disabled, setDisabled] = useState(false);
	const { question } = props;
	const classes = feedbackStyle();

	if (!question || question.type !== "scale") {
		return null;
	}

	const containerClasses = [
		classes.scaleContainer,
		disabled ? classes.disabled : "",
	];

	const values = Array.from(
		{ length: question.config.max },
		(_, i) => i + 1
	).slice(question.config.min - 1, question.config.max);

	const handleChange = (value: number) => {
		if (value === rating) {
			return;
		}
		setRating(value);
		if (props.onChange) {
			props.onChange(question.id, `${value}`);
		}
		setDisabled(true);
		setTimeout(() => {
			setDisabled(false);
		}, 800);
	};

	const leftTextArray = question.config.leftText?.split("$br$");
	const rightTextArray = question.config.rightText?.split("$br$");

	return (
		<div
			style={{
				width: "100%",
				display: "flex",
				flexDirection: "column",
			}}
		>
			<div className={containerClasses.join(" ")}>
				{values.map((value, index) => {
					const currentClasses = [
						classes.scaleValue,
						rating >= value ? classes.scaleValueActive : "",
						rating === value ? classes.scaleValueSelected : "",
					];

					return (
						<div
							className={currentClasses.join(" ")}
							onClick={() => handleChange(value)}
							key={`${question.commonId}-${index}`}
						>
							<Typography
								variant="body2"
								color="textSecondary"
								className={classes.scaleValueText}
							>
								{value}
							</Typography>
						</div>
					);
				})}
			</div>
			{question.config.leftText && question.config.rightText && (
				<div className={classes.scaleTextContainer}>
					<Typography
						variant="caption"
						color="textSecondary"
						style={{ marginTop: "2px", lineHeight: "0.95rem" }}
					>
						{leftTextArray?.map((text, index) => {
							return (
								<React.Fragment key={index}>
									{text}
									<br />
								</React.Fragment>
							);
						})}
					</Typography>
					<Typography
						variant="caption"
						color="textSecondary"
						align="right"
						style={{ marginTop: "2px", lineHeight: "0.75rem" }}
					>
						{rightTextArray?.map((text, index) => {
							return (
								<React.Fragment key={index}>
									{text}
									<br />
								</React.Fragment>
							);
						})}
					</Typography>
				</div>
			)}
		</div>
	);
};
